import { render, staticRenderFns } from "./HeroVideo.vue?vue&type=template&id=a67875a4&scoped=true&"
import script from "./HeroVideo.vue?vue&type=script&lang=js&"
export * from "./HeroVideo.vue?vue&type=script&lang=js&"
import style0 from "./HeroVideo.vue?vue&type=style&index=0&id=a67875a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67875a4",
  null
  
)

export default component.exports